import { Observable } from "rxjs";
import { ListarUbigeosPeruRequest, ObtenerParametrosRequest, ParametroRequest, ParametrosNSRequest, listarEntidadesRequest, listarPuertosRequest } from "../domain/parametros.request";
import { ObtenerParametrosResponse, ParametroResponse, ParametrosNSResponse } from "../domain/parametros.response";

export abstract class parametrosRepository {

    abstract listarPuertos(request: listarPuertosRequest): Observable<any>
    abstract listarEntidades(request: listarEntidadesRequest): Observable<any>
    abstract ListarServicios(): Observable<any>
    abstract ObtenerParametros(request: ObtenerParametrosRequest): Observable<ObtenerParametrosResponse>
    abstract ListarUbigeosPeru(request: ListarUbigeosPeruRequest): Observable<any>
    abstract ObtenerParametrosValor(request: ParametroRequest): Observable<ParametroResponse>
    abstract getTblParametros(request: ParametrosNSRequest): Observable<ParametrosNSResponse>

}
